import { Tooltip, TooltipProps } from "@mui/material";
import "./PortalTooltip.css";

export type MUITooltipPlacement = TooltipProps["placement"];

interface Props {
	children: React.ReactElement<any, any>;
	title: React.ReactNode;
	placement?: MUITooltipPlacement;
	/** "center" (default) centers the tooltip horizontally; "anchor" keeps it near the triggering element */
	align?: "center" | "anchor";
}

export function PortalTooltip({ children, title, placement, align = "center" }: Props) {
	const popperClass = align === "anchor" ? "portal-tooltip portal-tooltip-anchor" : "portal-tooltip";
	return (
		<Tooltip placement={placement} title={title} classes={{ popper: popperClass }}>
			{children}
		</Tooltip>
	);
}
